import axiosInstance from '../../../axiosInstance'
import apiEndpoints from '../../../api'


export const getMemberDaybookReq = (action) => {
    const { societyId, ...params } = action?.data || {};
    const url = apiEndpoints.GET_MEMBER_DAYBOOK_API.replace(':societyId', societyId);
    return axiosInstance.get(url, { params });
}
